<div class="login-screen">
  <div class="login-brand-panel">
    <div class="brand-panel-glow"></div>
    <div class="brand-panel-content">
      <img src="/assets/logo.png" alt="Fork & Find" class="brand-logo" />
      <div class="brand-illustration">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
        >
          <path
            d="M17.0019 17.3738L10.8516 23.6048C10.3315 24.1317 9.49333 24.1317 8.97325 23.6048L2.82297 17.3738C1.26305 15.7904 0.324608 13.8149 0.00765015 11.7599C-0.0513471 11.3773 0.238432 11.0405 0.616769 11.0223L3.32899 10.8914C3.81255 10.8674 4.27184 11.1026 4.53177 11.5072L5.1269 12.4337C5.94803 13.712 7.42775 14.421 8.94912 14.2651L15.5902 13.5844C15.9509 13.5475 16.225 13.2463 16.225 12.8871C16.225 12.4999 15.9082 12.186 15.5173 12.186L9.66341 12.186C9.19881 12.186 8.82218 11.8129 8.82218 11.3526C8.82218 10.8924 9.19881 10.5193 9.66341 10.5193H15.552C15.9237 10.5193 16.225 10.2208 16.225 9.85261C16.225 9.48441 15.9237 9.18592 15.552 9.18592H9.66341C9.19881 9.18592 8.82218 8.81282 8.82218 8.35257C8.82218 7.89232 9.19881 7.51921 9.66341 7.51921H15.5173C15.9082 7.51921 16.225 7.20533 16.225 6.81814C16.225 6.45887 15.9509 6.15775 15.5902 6.12078L8.94912 5.44013C7.42775 5.28421 5.94803 5.99319 5.1269 7.27149L4.53177 8.19797C4.27184 8.60262 3.81255 8.83779 3.32899 8.81384L0.738004 8.6888C0.342736 8.66972 0.0486517 8.30439 0.137033 7.91003C0.541873 6.10362 1.43718 4.38758 2.82297 2.98088C6.73837 -0.993627 13.0865 -0.993627 17.0019 2.98088C20.9173 6.95539 20.9173 13.3993 17.0019 17.3738Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <h1 class="brand-heading">Dining, Reimagined by Intelligence</h1>
      <p class="brand-subheading">
        Configure your active dining tables, link with Clover or Square terminals, and put an
        intelligent operating layer in every server's hands.
      </p>
    </div>
  </div>

  <div class="login-form-panel">
    <div class="signup-widget">
      <div class="logo">
        <img src="/assets/logo.png" alt="Company Logo" height="32" width="107" />
      </div>
      <div class="main">
        <div class="login-body">
          <div class="login-heading">
            <h2>Sign in</h2>
            <p>Enter your credentials to access your dashboard.</p>
          </div>
          <form class="form" [formGroup]="loginInfo" autocomplete="off" (ngSubmit)="onSubmit()">
            <div class="login-field-row">
              <div class="text-form-field">
                <label for="email" class="label">Email</label>
                <div class="input-with-icon">
                  <i class="bx bx-envelope input-icon"></i>
                  <input
                    id="email"
                    type="text"
                    formControlName="username"
                    class="email"
                    placeholder="you@restaurant.com"
                    (keyup)="removeErrorMessage()"
                  />
                </div>
                @if (showUsernameError) {
                  <div class="d-flex error gap-3 align-items-baseline">
                    <mat-icon svgIcon="warning-icon" class="warning-icon pb-1"></mat-icon>
                    @if (usernameCtrl?.hasError('required')) {
                      <p>Email cannot be empty.</p>
                    } @else if (usernameCtrl?.hasError('pattern')) {
                      <p>Email cannot contain spaces.</p>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="login-field-row">
              <div class="text-form-field">
                <label for="password" class="label">Password</label>
                <div class="password-input-wrapper input-with-icon">
                  <i class="bx bx-lock-alt input-icon"></i>
                  <input
                    id="password"
                    [type]="showPassword ? 'text' : 'password'"
                    formControlName="password"
                    class="password"
                    placeholder="Enter your password"
                    (keyup)="removeErrorMessage()"
                  />
                  <button
                    type="button"
                    class="password-toggle-btn"
                    (click)="togglePasswordVisibility()"
                    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                  >
                    <i [class]="showPassword ? 'bx bx-hide' : 'bx bx-show'"></i>
                  </button>
                </div>
                @if (submitted && formControls['password'].invalid) {
                  <div class="error">
                    <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                    <p>Password cannot be empty.</p>
                  </div>
                } @else {
                  <p class="info">Must be at least 8 characters long.</p>
                }
              </div>
            </div>
            @if (submitted && errorMessage != '') {
              <div class="error">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p class="pt-2 pl-2">{{ errorMessage }}</p>
              </div>
            }
            <button
              type="submit"
              class="btn-login"
              [class.is-loading]="isLoading"
              [disabled]="isLoading"
              [attr.aria-busy]="isLoading"
            >
              @if (isLoading) {
                <span class="btn-login-spinner" aria-hidden="true"></span>
              }
              Login
              @if (!isLoading) {
                <i class="bx bx-right-arrow-alt"></i>
              }
            </button>
          </form>
          <div class="terms">
            <p>
              By logging in, you agree to our
              <a [href]="legalUrls.terms" target="_blank" rel="noopener">Terms of Service</a> and
              <a [href]="legalUrls.privacy" target="_blank" rel="noopener">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </div>
      <div class="policy">
        <p>Copyright © {{ currentYear }} Fork & Find. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</div>
